/* src/app/components/lead-details/benefits/benefits.component.css */
/*# sourceMappingURL=benefits.component-GIFOMKJF.css.map */
